import { useAtom, useSetAtom } from 'jotai'
import Button from 'src/common/ui-kit/Button/Button'
import Modal from 'src/common/ui-kit/Modal'
import {
  kycModalAtom,
  verifyModalAtom,
} from 'src/pages/TradePage/stores/trade-store'

const VerifyModal = () => {
  const [verifyModal, setVerifyModal] = useAtom(verifyModalAtom)
  const setKycModal = useSetAtom(kycModalAtom)

  return (
    <Modal open={verifyModal} onClose={() => setVerifyModal(false)}>
      <div className='py-2'>
        <div className='typo-title3 mb-2 text-center text-main-accent font-bold'>
          Enable your account
        </div>
        <div className='typo-label2 text-main-accent mb-2'>
          Trading carbon credits is only permitted for qualified users. Start
          the identity verification process below.
        </div>
        <Button
          className='w-full mb-2'
          onClick={() => {
            setVerifyModal(false)
            setKycModal(true)
          }}
        >
          Individual - Start here
        </Button>
        {/* <Button
        className='w-full'
        onClick={() =>
          window.open('https://app.swarm.com/v1/onboarding', '_blank')
        }
      >
        Business - Start here
      </Button> */}
      </div>
    </Modal>
  )
}

export default VerifyModal
